import { KpiV2FontSize } from '../../dashboards/types';
import { KpiUiSubValue } from '../types';

// UI Layout Enum
export enum KpiUiLayout {
  SINGLE_COLUMN = 'singleColumn',
  TWO_COLUMN = 'twoColumn',
}

// Section interfaces
export interface KpiUiSingleColumnSection {
  mainValue?: string;
  subValues?: KpiUiSubValue[];
}

export interface KpiUiTwoColumnSection {
  title?: string;
  mainValue?: string;
  subValues?: KpiUiSubValue[];
}

// Common props for both UI types
interface KpiUiCommonProps {
  title?: string;
  subtitle?: string;
  footer?: string;
}

// Single column specific options
export interface KpiUiSingleColumnOptions extends KpiUiCommonProps {
  layout: KpiUiLayout.SINGLE_COLUMN;
  section: KpiUiSingleColumnSection;
  fontSize?: KpiV2FontSize;
}

// Two column specific props
export interface KpiUiTwoColumnOptions extends KpiUiCommonProps {
  layout: KpiUiLayout.TWO_COLUMN;
  sections: {
    leftSection: KpiUiTwoColumnSection;
    rightSection: KpiUiTwoColumnSection;
  };
  fontSize?: KpiV2FontSize;
}

// Union type for all possible options
export type KpiUiOptions = KpiUiSingleColumnOptions | KpiUiTwoColumnOptions;
